export function GradientCircleIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg {...props} fill="none" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <rect fill="url(#paint0_linear_13084_19043)" height="30" rx="15" width="30" />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_13084_19043"
          x1="-2.30769"
          x2="35.0955"
          y1="4.25715e-07"
          y2="9.13387"
        >
          <stop stopColor="#0993EC" />
          <stop offset="1" stopColor="#F338C3" />
        </linearGradient>
      </defs>
    </svg>
  )
}
